module.exports = __webpack_public_path__ + "hamburger.135a3b09.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/hamburger.svg
 ** module id = 245
 ** module chunks = 0
 **/